import { Theme } from '@mui/material';

export const THEMES: Record<string, string> = {
	LIGHT: `light`,
	DARK: `dark`,
};
export const lightTheme = (theme: Theme): boolean => theme.palette.mode === `light`;
export const secondarySideBarWidth = 215;
export const secondarySideBarGap = 80;
